// extracted by mini-css-extract-plugin
module.exports = {"pinInput":"dB"};